import axios from "axios";
import {
  CREATE_HX_RULES_FAIL,
  CREATE_HX_RULES_REQUEST,
  CREATE_HX_RULES_SUCCESS,
  CREATE_AGENCY_BOOKING_REPORT_RULES_FAIL,
  CREATE_AGENCY_BOOKING_REPORT_RULES_REQUEST,
  CREATE_AGENCY_BOOKING_REPORT_RULES_SUCCESS,
  CREATE_SC_RULES_FAIL,
  CREATE_SC_RULES_REQUEST,
  CREATE_SC_RULES_SUCCESS,
  GET_AIRLINES_DETAILS_FAIL,
  GET_AIRLINES_DETAILS_REQUEST,
  GET_AIRLINES_DETAILS_SUCCESS,
  GET_ALL_HX_RULES_FAIL,
  GET_AL_HX_RULES_REQUEST,
  GET_ALL_HX_RULES_SUCCESS,
  GET_ALL_AGENCY_BOOKING_REPORT_RULES_FAIL,
  GET_AL_AGENCY_BOOKING_REPORT_RULES_REQUEST,
  GET_ALL_AGENCY_BOOKING_REPORT_RULES_SUCCESS,
  GET_ALL_SC_RULES_FAIL,
  GET_AL_SC_RULES_REQUEST,
  GET_ALL_SC_RULES_SUCCESS,
  GET_SERVER_LOGS_SUCCESS,
  GET_SERVER_LOGS_REQUEST,
  GET_SERVER_LOGS_FAIL,
  SEND_OTP_FAIL,
  SEND_OTP_REQUECT,
  SEND_OTP_SUCCESS,
  USER_LOGIN_FAIL,
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGOUT,
  CREATE_CUSTOMER_REQUEST,
  CREATE_CUSTOMER_SUCCESS,
  CREATE_CUSTOMER_FAIL,
  GET_ALL_CUSTOMERS_REQUEST,
  GET_ALL_CUSTOMERS_SUCCESS,
  GET_HX_RULE_REQUEST,
  GET_HX_RULE_SUCCESS,
  GET_HX_RULE_FAIL,
  GET_AGENCY_BOOKING_REPORT_RULE_REQUEST,
  GET_AGENCY_BOOKING_REPORT_RULE_SUCCESS,
  GET_AGENCY_BOOKING_REPORT_RULE_FAIL,
  GET_SC_RULE_REQUEST,
  GET_SC_RULE_SUCCESS,
  GET_SC_RULE_FAIL,
  GET_ALL_CUSTOMERS_FAIL,
  GET_CUSTOMER_REQUEST,
  GET_CUSTOMER_SUCCESS,
  GET_CUSTOMER_FAIL,
  UPDATE_HX_RULE_REQUEST,
  UPDATE_HX_RULE_SUCCESS,
  UPDATE_HX_RULE_FAIL,
  UPDATE_AGENCY_BOOKING_REPORT_RULE_REQUEST,
  UPDATE_AGENCY_BOOKING_REPORT_RULE_SUCCESS,
  UPDATE_AGENCY_BOOKING_REPORT_RULE_FAIL,
  UPDATE_SC_RULE_REQUEST,
  UPDATE_SC_RULE_SUCCESS,
  UPDATE_SC_RULE_FAIL,
  UPDATE_CUSTOMER_REQUEST,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_FAIL,
  DELETE_HX_RULE_REQUEST,
  DELETE_HX_RULE_SUCCESS,
  DELETE_HX_RULE_FAIL,
  DELETE_AGENCY_BOOKING_REPORT_RULE_REQUEST,
  DELETE_AGENCY_BOOKING_REPORT_RULE_SUCCESS,
  DELETE_AGENCY_BOOKING_REPORT_RULE_FAIL,
  DELETE_SC_RULE_REQUEST,
  DELETE_SC_RULE_SUCCESS,
  DELETE_SC_RULE_FAIL,
  DELETE_CUSTOMER_REQUEST,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_FAIL,
  GET_ALL_COUNTRY_REQUEST,
  GET_ALL_COUNTRY_SUCCESS,
  GET_ALL_COUNTRY_FAIL,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_FAIL,
  UPDATE_USER_REQUEST,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAIL,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  GET_MANAGE_BOOKING_DATA_FAIL,
  GET_MANAGE_BOOKING_DATA_REQUEST,
  GET_MANAGE_BOOKING_DATA_SUCCESS,
  PRINT_ITINERARY_DATA_FAIL,
  PRINT_ITINERARY_DATA_REQUEST,
  PRINT_ITINERARY_DATA_SUCCESS,
  EMAIL_ITINERARY_DATA_REQUEST,
  EMAIL_ITINERARY_DATA_SUCCESS,
  EMAIL_ITINERARY_DATA_FAIL,
  GET_ALL_USERS_REQUEST,
  GET_ALL_USERS_SUCCESS,
  GET_ALL_USERS_FAIL,
  CREATE_USER_REQUEST,
  CREATE_USER_SUCCESS,
  CREATE_USER_FAIL,
  DELETE_USER_REQUEST,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  GET_LOGGED_IN_USER_REQUEST,
  GET_LOGGED_IN_USER_SUCCESS,
  GET_LOGGED_IN_USER_FAIL,
  GET_PRODUCTS_REQUEST,
  GET_PRODUCTS_SUCCESS,
  GET_PRODUCTS_FAIL,
  GET_USER_PERMISSION_REQUEST,
  GET_USER_PERMISSION_SUCCESS,
  GET_USER_PERMISSION_FAIL,
  CHECK_PCC_REQUEST,
  CHECK_PCC_SUCCESS,
  CHECK_PCC_FAIL,
  GET_ALL_ACTIVE_CUSTOMERS_REQUEST,
  GET_ALL_ACTIVE_CUSTOMERS_SUCCESS,
  GET_ALL_ACTIVE_CUSTOMERS_FAIL,
  GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_REQUEST,
  GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_SUCCESS,
  GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_FAIL,
  GET_TP_BATCH_REPORT_REQUEST,
  GET_TP_BATCH_REPORT_SUCCESS,
  GET_TP_BATCH_REPORT_FAIL,
  EMAIL_MULTI_PCC_TICKET_REPORT_REQUEST,
  EMAIL_MULTI_PCC_TICKET_REPORT_SUCCESS,
  EMAIL_MULTI_PCC_TICKET_REPORT_FAIL,
  GET_TICKET_REPORT_REQUEST,
  GET_TICKET_REPORT_SUCCESS,
  GET_TICKET_REPORT_FAIL,
  GET_CURRENCY_REQUEST,
  GET_CURRENCY_SUCCESS,
  GET_CURRENCY_FAIL,
  DOWNLOAD_EXCEL_REQUEST,
  DOWNLOAD_EXCEL_SUCCESS,
  DOWNLOAD_EXCEL_FAIL,
  DOWNLOAD_CSV_REQUEST,
  DOWNLOAD_CSV_FAIL,
  DOWNLOAD_CSV_SUCCESS,
  GET_CUSTOMER_STATIC_DATA_REQUEST,
  GET_CUSTOMER_STATIC_DATA_SUCCESS,
  GET_CUSTOMER_STATIC_DATA_FAIL,
  CREATE_CUSTOMER_LOGIN_REQUEST,
  CREATE_CUSTOMER_LOGIN_SUCCESS,
  CREATE_CUSTOMER_LOGIN_FAIL,
  GET_ALL_CUSTOMERS_LOGINS_REQUEST,
  GET_ALL_CUSTOMERS_LOGINS_SUCCESS,
  GET_ALL_CUSTOMERS_LOGINS_FAIL,
  UPDATE_CUSTOMER_LOGINS_REQUEST,
  UPDATE_CUSTOMER_LOGINS_SUCCESS,
  UPDATE_CUSTOMER_LOGINS_FAIL,
  GET_ALL_PARENT_CUSTOMERS_REQUEST,
  GET_ALL_PARENT_CUSTOMERS_SUCCESS,
  GET_ALL_PARENT_CUSTOMERS_FAIL,
  REMOVE_CUSTOMER_LOGO_REQUEST,
  REMOVE_CUSTOMER_LOGO_SUCCESS,
  REMOVE_CUSTOMER_LOGO_FAIL,
  GET_QUEUELIST_FAIL,
  GET_QUEUELIST_REQUEST,
  GET_QUEUELIST_SUCCESS,
  GET_QUEUELIST_RESET,
  DOWNLOAD_INVOICE_SUCCESS,
  DOWNLOAD_INVOICE_FAIL,
  DOWNLOAD_INVOICE_REQUEST,

} from "../../Constants/Constants";
import { LOCAL_URL } from "../../Constants/global";

export const getAirlineDetails = () => async (dispatch) => {
  try {
    dispatch({ type: GET_AIRLINES_DETAILS_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(`${LOCAL_URL}/get_all_airline`, config);

    dispatch({ type: GET_AIRLINES_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_AIRLINES_DETAILS_FAIL, payload: error });
  }
};

export const createHXRule = (hx_rule_data) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_HX_RULES_REQUEST });
    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.post(
      `${LOCAL_URL}/add_hx_rules`,
      hx_rule_data,
      config
    );

    dispatch({ type: CREATE_HX_RULES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: CREATE_HX_RULES_FAIL, payload: error });
  }
};

export const createAgencyBookingReportRule =
  (agency_booking_report_rule_data) => async (dispatch) => {
    try {
      dispatch({ type: CREATE_AGENCY_BOOKING_REPORT_RULES_REQUEST });
      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.post(
        `${LOCAL_URL}/add_agency_booking_report_rules`,
        agency_booking_report_rule_data,
        config
      );

      dispatch({
        type: CREATE_AGENCY_BOOKING_REPORT_RULES_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: CREATE_AGENCY_BOOKING_REPORT_RULES_FAIL,
        payload: error,
      });
    }
  };
export const createSCRule = (sc_rule_data) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_SC_RULES_REQUEST });
    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.post(
      `${LOCAL_URL}/add_qca_rules`,
      sc_rule_data,
      config
    );

    dispatch({ type: CREATE_SC_RULES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: CREATE_SC_RULES_FAIL, payload: error });
  }
};

export const createCustomer =
  (customer_data, static_data, logo, footerLogo) => async (dispatch) => {
    try {
      dispatch({ type: CREATE_CUSTOMER_REQUEST });
      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      };

      const formData = new FormData();
      formData.append("customer_data", JSON.stringify(customer_data));
      formData.append("customer_static_data", JSON.stringify(static_data));

      if (logo) {
        formData.append("logo", logo);
      }
      if (footerLogo) {
        formData.append("footer_logo", footerLogo);
      }

      const plainObject = Object.fromEntries(formData);

      const { data } = await axios.post(
        `${LOCAL_URL}/create_customer`,
        plainObject,
        config
      );

      dispatch({ type: CREATE_CUSTOMER_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: CREATE_CUSTOMER_FAIL, payload: error });
    }
  };

export const login = (login_data) => async (dispatch) => {
  try {
    dispatch({
      type: USER_LOGIN_REQUEST,
    });

    const config = {
      headers: {
        "Content-type": "application/json",
      },
    };

    const { data } = await axios.post(`${LOCAL_URL}/login`, login_data, config);

    dispatch({
      type: USER_LOGIN_SUCCESS,
      payload: data,
    });

    const expirationTime = new Date(new Date().getTime() + 12 * 60 * 60000); // 30 minutes expiration time

    localStorage.setItem("userInfo", JSON.stringify(data["access_token"]));
    localStorage.setItem("user_id", JSON.stringify(data["user_id"]));
    localStorage.setItem("user_email", login_data["email"]);
    localStorage.setItem("tokenExpiration", expirationTime);

    window.location.reload();
  } catch (error) {
    dispatch({
      type: USER_LOGIN_FAIL,
      payload: error.response.data,
    });
  }
};

export const logout = () => async (dispatch) => {
  localStorage.removeItem("userInfo");
  localStorage.removeItem("user_email");
  localStorage.removeItem("tokenExpiration");
  localStorage.removeItem("user_id");
  sessionStorage.removeItem("pnr");
  sessionStorage.removeItem("pcc");

  dispatch({
    type: USER_LOGOUT,
  });
  window.location.reload();
};

export const sendOTP = (requestData) => async (dispatch) => {
  try {
    dispatch({
      type: SEND_OTP_REQUECT,
    });

    const config = {
      headers: {
        "Content-type": "application/json",
      },
    };

    const { data } = await axios.post(
      `${LOCAL_URL}/send_otp_mail`,
      requestData,
      config
    );

    localStorage.setItem("user_id", JSON.stringify(data["user_id"]));

    dispatch({
      type: SEND_OTP_SUCCESS,
      payload: data.message,
    });
  } catch (error) {
    dispatch({
      type: SEND_OTP_FAIL,
      payload: error.response.data,
    });
  }
};

export const getHXRules = (search_value) => async (dispatch) => {
  try {
    dispatch({ type: GET_AL_HX_RULES_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const url = search_value
      ? `${LOCAL_URL}/get_all_hx_rules/${search_value}`
      : `${LOCAL_URL}/get_all_hx_rules`;

    const { data } = await axios.get(url, config);

    dispatch({ type: GET_ALL_HX_RULES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_HX_RULES_FAIL, payload: error });
  }
};

export const getAgencyBookingReportRules = (search_value) => async (dispatch) => {
  try {
    dispatch({ type: GET_AL_AGENCY_BOOKING_REPORT_RULES_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const url = search_value
      ? `${LOCAL_URL}/get_all_agency_booking_report_rules/${search_value}`
      : `${LOCAL_URL}/get_all_agency_booking_report_rules`;

    const { data } = await axios.get(url, config);

    dispatch({
      type: GET_ALL_AGENCY_BOOKING_REPORT_RULES_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_AGENCY_BOOKING_REPORT_RULES_FAIL,
      payload: error,
    });
  }
};
export const getSCRules = (search_value) => async (dispatch) => {
  try {
    dispatch({ type: GET_AL_SC_RULES_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const url = search_value
      ? `${LOCAL_URL}/get_all_qca_rules/${search_value}`
      : `${LOCAL_URL}/get_all_qca_rules`;

    const { data } = await axios.get(url, config);

    dispatch({ type: GET_ALL_SC_RULES_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_SC_RULES_FAIL, payload: error });
  }
};
export const getServerLogs = (search_value = "", log_type = "") => async (dispatch) => {
  try {
    dispatch({ type: GET_SERVER_LOGS_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    // Construct URL dynamically
    let url = `${LOCAL_URL}/get_all_server_logs`;

    if (log_type) {
      url += `/${log_type}`;
    }

    if (search_value) {
      const separator = url.includes("?") ? "&" : "?";
      url += `${separator}search=${encodeURIComponent(search_value)}`;
    }

    const { data } = await axios.get(url, config);

    dispatch({ type: GET_SERVER_LOGS_SUCCESS, payload: data });
  } catch (error) {
    const message =
      error.response?.data?.detail || error.message || "Failed to fetch logs";
    dispatch({ type: GET_SERVER_LOGS_FAIL, payload: message });
  }
};

export const getCustomer =
  (search_value = "", search_by = "name", page = null, per_page = null) =>
  async (dispatch) => {
    try {
      dispatch({ type: GET_ALL_CUSTOMERS_REQUEST });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      let url = `${LOCAL_URL}/get_all_customer`;
      const query = new URLSearchParams();

      if (search_value) {
        query.set("search_by", search_by);
        query.set("search", search_value);
      }

      if (page) {
        query.set("page", page);
      }

      if (per_page) {
        query.set("per_page", per_page);
      }

      if (query.toString()) {
        url = `${url}?${query.toString()}`;
      }

      const { data } = await axios.get(url, config);

      dispatch({ type: GET_ALL_CUSTOMERS_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: GET_ALL_CUSTOMERS_FAIL, payload: error });
    }
  };
export const getQCACustomer = (search_value) => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_CUSTOMERS_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const url = search_value
      ? `${LOCAL_URL}/get_customer_for_qca_rule/${search_value}`
      : `${LOCAL_URL}/get_customer_for_qca_rule`;

    const { data } = await axios.get(url, config);

    dispatch({ type: GET_ALL_CUSTOMERS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_CUSTOMERS_FAIL, payload: error });
  }
};

export const getActiveCustomers = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_ACTIVE_CUSTOMERS_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/get_all_active_customers_name`,
      config
    );

    dispatch({ type: GET_ALL_ACTIVE_CUSTOMERS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_ACTIVE_CUSTOMERS_FAIL, payload: error });
  }
};

export const getActiveReportEnabledCustomers = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/get_all_active_report_enabled_customers`,
      config
    );

    dispatch({
      type: GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: GET_ALL_ACTIVE_REPORT_ENABLED_CUSTOMERS_FAIL,
      payload: error,
    });
  }
};

export const getHXRuleByID = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_HX_RULE_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/get_hx_rule_by_id/${id}`,
      config
    );

    dispatch({ type: GET_HX_RULE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_HX_RULE_FAIL, payload: error });
  }
};

export const getAgencyBookingReportRuleByID = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_AGENCY_BOOKING_REPORT_RULE_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/get_agency_booking_report_rule_by_id/${id}`,
      config
    );

    dispatch({ type: GET_AGENCY_BOOKING_REPORT_RULE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_AGENCY_BOOKING_REPORT_RULE_FAIL, payload: error });
  }
};
export const getSCRuleByID = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_SC_RULE_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/get_qca_rule/${id}`,
      config
    );

    dispatch({ type: GET_SC_RULE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_SC_RULE_FAIL, payload: error });
  }
};
export const getQueueListByPCC = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_QUEUELIST_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/get_qca_by_pcc/${id}`,
      config
    );

    dispatch({ type: GET_QUEUELIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_QUEUELIST_FAIL, payload: error });
  }
};


export const getCustomerByID = (id) => async (dispatch) => {
  try {


    dispatch({ type: GET_CUSTOMER_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/get_customer_by_id/${id}`,
      config
    );

    dispatch({ type: GET_CUSTOMER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_CUSTOMER_FAIL, payload: error });
  }
};

export const getCustomerStaticDataByCustID = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_CUSTOMER_STATIC_DATA_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/get_customer_static_data/${id}`,
      config
    );

    dispatch({ type: GET_CUSTOMER_STATIC_DATA_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_CUSTOMER_STATIC_DATA_FAIL, payload: error });
  }
};

export const updateHXRule = (hx_rule_id, hx_rule) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_HX_RULE_REQUEST,
    });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.put(
      `${LOCAL_URL}/update_hx_rule/${hx_rule_id}`,
      hx_rule,
      config
    );

    dispatch({
      type: UPDATE_HX_RULE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_HX_RULE_FAIL,
      palyload: error.response.data,
    });
  }
};

export const updateAgencyBookingReportRule =
  (agency_booking_report_rule_id, agency_booking_report_rule) =>
  async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_AGENCY_BOOKING_REPORT_RULE_REQUEST,
      });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.put(
        `${LOCAL_URL}/update_agency_booking_report_rule/${agency_booking_report_rule_id}`,
        agency_booking_report_rule,
        config
      );

      dispatch({
        type: UPDATE_AGENCY_BOOKING_REPORT_RULE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_AGENCY_BOOKING_REPORT_RULE_FAIL,
        payload: error.response?.data || error,
      });
    }
  };
export const updateSCRule = (sc_rule_id, sc_rule) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_SC_RULE_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.put(
      `${LOCAL_URL}/update_qca_rule/${sc_rule_id}`,
      sc_rule,
      config
    );

    dispatch({
      type: UPDATE_SC_RULE_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_SC_RULE_FAIL,
      payload:
        error.response?.data ||
        "Something went wrong while updating rule",
    });
  }
};


export const updateCustomer =
  (customer_id, customer, static_data, logo, footerLogo) => async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_CUSTOMER_REQUEST,
      });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      };

      const formData = new FormData();
      // formData.append("customer_id", customer_id);
      formData.append("customer_update", JSON.stringify(customer));
      formData.append("customer_static_data", JSON.stringify(static_data));
      if (logo) {
        formData.append("logo", logo);
      }
      if (footerLogo) {
        formData.append("footer_logo", footerLogo);
      }

      const plainObject = Object.fromEntries(formData);

      const { data } = await axios.put(
        `${LOCAL_URL}/update_customer/${customer_id}`,
        plainObject,
        config
      );

      dispatch({
        type: UPDATE_CUSTOMER_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_CUSTOMER_FAIL,
        palyload: error.response.data,
      });
    }
  };

export const deleteHXRule = (id) => async (dispatch) => {
  try {
    dispatch({
      type: DELETE_HX_RULE_REQUEST,
    });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    await axios.delete(`${LOCAL_URL}/delete_hx_rule/${id}`, config);

    dispatch({
      type: DELETE_HX_RULE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: DELETE_HX_RULE_FAIL,
      palyload: error,
    });
  }
};

export const deleteAgencyBookingReportRule = (id) => async (dispatch) => {
  try {
    dispatch({
      type: DELETE_AGENCY_BOOKING_REPORT_RULE_REQUEST,
    });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    await axios.delete(
      `${LOCAL_URL}/delete_agency_booking_report_rule/${id}`,
      config
    );

    dispatch({
      type: DELETE_AGENCY_BOOKING_REPORT_RULE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: DELETE_AGENCY_BOOKING_REPORT_RULE_FAIL,
      payload: error,
    });
  }
};
export const deleteSCRule = (id) => async (dispatch) => {
  try {
    dispatch({
      type: DELETE_SC_RULE_REQUEST,
    });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    await axios.delete(`${LOCAL_URL}/delete_qca_rule/${id}`, config);

    dispatch({
      type: DELETE_SC_RULE_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: DELETE_SC_RULE_FAIL,
      palyload: error,
    });
  }
};

export const deleteCustomer = (id) => async (dispatch) => {
  try {
    dispatch({
      type: DELETE_CUSTOMER_REQUEST,
    });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    await axios.delete(`${LOCAL_URL}/delete_customer/${id}`, config);

    dispatch({
      type: DELETE_CUSTOMER_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: DELETE_CUSTOMER_FAIL,
      palyload: error,
    });
  }
};

export const getAllCountry = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_COUNTRY_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(`${LOCAL_URL}/get_all_countries`, config);
    // const countryNames = data.map((country) => country.name);

    dispatch({ type: GET_ALL_COUNTRY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_COUNTRY_FAIL, payload: error });
  }
};

export const getUserByID = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_USER_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/get_user_by_id/${id}`,
      config
    );

    dispatch({ type: GET_USER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_USER_FAIL, payload: error.response.data });
  }
};

export const getLoggedInUser = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_LOGGED_IN_USER_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/get_user_by_id/${id}`,
      config
    );

    dispatch({ type: GET_LOGGED_IN_USER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_LOGGED_IN_USER_FAIL, payload: error.response.data });
  }
};

export const getAllUser = (search_value) => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_USERS_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const url = search_value
      ? `${LOCAL_URL}/get_all_users/${search_value}`
      : `${LOCAL_URL}/get_all_users`;
    const { data } = await axios.get(url, config);

    dispatch({ type: GET_ALL_USERS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_USERS_FAIL, payload: error });
  }
};

export const createUser = (user_data) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_USER_REQUEST });
    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.post(
      `${LOCAL_URL}/add_user`,
      user_data,
      config
    );

    dispatch({ type: CREATE_USER_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: CREATE_USER_FAIL, payload: error });
  }
};

export const deleteUser = (id) => async (dispatch) => {
  try {
    dispatch({
      type: DELETE_USER_REQUEST,
    });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    await axios.delete(`${LOCAL_URL}/delete_user/${id}`, config);

    dispatch({
      type: DELETE_USER_SUCCESS,
    });
  } catch (error) {
    dispatch({
      type: DELETE_USER_FAIL,
      palyload: error,
    });
  }
};

export const updateUser = (user_id, user) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_USER_REQUEST,
    });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.put(
      `${LOCAL_URL}/update_user/${user_id}`,
      user,
      config
    );

    dispatch({
      type: UPDATE_USER_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: UPDATE_USER_FAIL,
      palyload: error.response.data,
    });
  }
};

export const resetPassword = (user_id, user) => async (dispatch) => {
  try {
    dispatch({
      type: RESET_PASSWORD_REQUEST,
    });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.put(
      `${LOCAL_URL}/reset_password/${user_id}`,
      user,
      config
    );

    dispatch({
      type: RESET_PASSWORD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: RESET_PASSWORD_FAIL,
      payload: error.response.data,
    });
  }
};

export const changePassword =
  (user_id, change_password_data) => async (dispatch) => {
    try {
      dispatch({
        type: CHANGE_PASSWORD_REQUEST,
      });

      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const { data } = await axios.put(
        `${LOCAL_URL}/change_password/${user_id}`,
        change_password_data,
        config
      );

      dispatch({
        type: CHANGE_PASSWORD_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: CHANGE_PASSWORD_FAIL,
        payload: error.response.data,
      });
    }
  };

export const getManageBookingData =
  (locator, pcc, userType) => async (dispatch) => {
    try {
      dispatch({ type: GET_MANAGE_BOOKING_DATA_REQUEST });
      const user_id = JSON.parse(localStorage.getItem("user_id"));
      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${LOCAL_URL}/itineraryInfo/?locator=${locator}&pc=1G&pcc=${pcc}&userType=${userType}&user_id=${user_id}`,
        config
      );

      dispatch({ type: GET_MANAGE_BOOKING_DATA_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: GET_MANAGE_BOOKING_DATA_FAIL, payload: error });
    }
  };

export const printItinerary =
  (itineararyData, userType, language) => async (dispatch) => {
    try {
      dispatch({ type: PRINT_ITINERARY_DATA_REQUEST });

      const config = {
        headers: {
          "Content-type": "application/json",
        },
        responseType: "blob",
      };

      const { data } = await axios.post(
        `${LOCAL_URL}/print_itinerary/${language}/${userType}`,
        itineararyData,
        config
      );

      const blob = new Blob([data], { type: "application/pdf" });

      const pdfURL = window.URL.createObjectURL(blob);

      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = pdfURL;

      document.body.appendChild(iframe);

      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
      };

      dispatch({ type: PRINT_ITINERARY_DATA_SUCCESS, payload: data });
    } catch (error) {
      dispatch({ type: PRINT_ITINERARY_DATA_FAIL, payload: error });
    }
  };

export const emailItinerary =
  (itineararyData, email_data, userType, language) => async (dispatch) => {
    try {
      dispatch({ type: EMAIL_ITINERARY_DATA_REQUEST });

      const config = {
        headers: {
          "Content-type": "application/json",
        },
      };

      const requestBody = {
        itineararyData,
        email_data,
      };

      const { data } = await axios.post(
        `${LOCAL_URL}/email_itinerary/${language}/${userType}`,
        requestBody,
        config
      );

      dispatch({ type: EMAIL_ITINERARY_DATA_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: EMAIL_ITINERARY_DATA_FAIL,
        payload: error.response.data,
      });
    }
  };

export const getProducts = () => async (dispatch) => {
  try {
    dispatch({ type: GET_PRODUCTS_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(`${LOCAL_URL}/get_products`, config);

    dispatch({ type: GET_PRODUCTS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_PRODUCTS_FAIL, payload: error });
  }
};

export const getUserPermission = (user_id) => async (dispatch) => {
  try {
    dispatch({ type: GET_USER_PERMISSION_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/get_user_permission/${user_id}`,
      config
    );

    dispatch({ type: GET_USER_PERMISSION_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_USER_PERMISSION_FAIL, payload: error });
  }
};

export const checkPCC = (pcc) => async (dispatch) => {
  try {
    dispatch({ type: CHECK_PCC_REQUEST });

    const config = {
      headers: {
        "Content-type": "application/json",
      },
      params: {
        pcc: pcc,
      },
    };

    const { data } = await axios.get(`${LOCAL_URL}/check_pcc`, config);

    dispatch({ type: CHECK_PCC_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: CHECK_PCC_FAIL, payload: error });
  }
};

export const getTicketReport =
  (customer_id, pcc, command, report_type = "g") =>
    async (dispatch) => {
      try {
        dispatch({ type: GET_TICKET_REPORT_REQUEST });

        const token = JSON.parse(localStorage.getItem("userInfo"));

        const config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        const { data } = await axios.get(
          `${LOCAL_URL}/ticket_report/?customer_id=${customer_id}&pcc=${pcc}&command=${command}&report_type=${report_type}`,
          config
        );

        dispatch({ type: GET_TICKET_REPORT_SUCCESS, payload: data });
      } catch (error) {
        dispatch({ type: GET_TICKET_REPORT_FAIL, payload: error });
      }
    };

export const getTpBatchReport =
  (customer_id, pcc,report_type, from_date, to_date, batch_id = null) =>
    async (dispatch) => {
      try {
        dispatch({ type: GET_TP_BATCH_REPORT_REQUEST });

        const token = JSON.parse(localStorage.getItem("userInfo"));

        const config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          params: {
            customer_id,
            pcc,
            report_type,
            from_date,
            to_date,
            batch_id,
          },
        };

        const { data } = await axios.get(
          `${LOCAL_URL}/tp_batch_report/`,
          config
        );

        dispatch({ type: GET_TP_BATCH_REPORT_SUCCESS, payload: data });
      } catch (error) {
        dispatch({ type: GET_TP_BATCH_REPORT_FAIL, payload: error });
      }
    };

export const emailMultiPccTicketReport = (request_data) => async (dispatch) => {
  try {
    dispatch({ type: EMAIL_MULTI_PCC_TICKET_REPORT_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.post(
      `${LOCAL_URL}/send_multi_pcc_ticket_report_email`,
      request_data,
      config
    );

    dispatch({ type: EMAIL_MULTI_PCC_TICKET_REPORT_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: EMAIL_MULTI_PCC_TICKET_REPORT_FAIL, payload: error });
    throw error;
  }
};

export const getCurrency = () => async (dispatch) => {
  try {
    dispatch({ type: GET_CURRENCY_REQUEST });

    const { data } = await axios.get(
      "https://openexchangerates.org/api/currencies.json"
    );

    dispatch({ type: GET_CURRENCY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_CURRENCY_FAIL, payload: error });
  }
};

export const downloadExcelFile =
  (file_name, response_data, reportType = "g", fileFormat) =>
    async (dispatch) => {
      try {
        dispatch({ type: DOWNLOAD_EXCEL_REQUEST });

        const config = {
          headers: {
            "Content-type": "application/json",
          },
          responseType: "blob",
        };

        const { data } = await axios.post(
          `${LOCAL_URL}/download_ticket_report_excel?file_format=${fileFormat}&report_type=${reportType}`,
          response_data,
          config
        );

        const blob = new Blob([data], {
          type:
            fileFormat === "xls"
              ? "application/vnd.ms-excel"
              : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = file_name
          ? `${file_name}_report.${fileFormat}`
          : `Report.${fileFormat}`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        dispatch({ type: DOWNLOAD_EXCEL_SUCCESS, payload: data });
      } catch (error) {
        dispatch({ type: DOWNLOAD_EXCEL_FAIL, payload: error });
      }
    };

export const downloadInvoiceFile =
  ( request_data,fileFormat="pdf") =>
    async (dispatch) => {
      try {
        dispatch({ type: DOWNLOAD_INVOICE_REQUEST });
        const token = JSON.parse(localStorage.getItem("userInfo"));
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        };

        const { data } = await axios.post(
          `${LOCAL_URL}/download_invoice_report_pdf`,
          request_data,
          config
        );

        const blob = new Blob([data], {
          type:
            fileFormat === "pdf"
              ? "application/pdf"
              : fileFormat === "xls"
                ? "application/vnd.ms-excel"
                : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const fileUrl = URL.createObjectURL(blob);

        dispatch({
          type: DOWNLOAD_INVOICE_SUCCESS,
          payload: {
            fileUrl,
            blob,
            fileName: "Invoice_Report.pdf", 
          },
        });
      } catch (error) {
        dispatch({ type: DOWNLOAD_INVOICE_FAIL, payload: error });
      }
    };

export const downloadInvoiceFileUpdated =
  ( request_data,fileFormat="pdf") =>
    async (dispatch) => {
      try {
        dispatch({ type: DOWNLOAD_INVOICE_REQUEST });
        const token = JSON.parse(localStorage.getItem("userInfo"));
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        };

        const { data } = await axios.post(
          `${LOCAL_URL}/download_invoice_report_pdf_live_fallback`,
          request_data,
          config
        );

        const blob = new Blob([data], {
          type:
            fileFormat === "pdf"
              ? "application/pdf"
              : fileFormat === "xls"
                ? "application/vnd.ms-excel"
                : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const fileUrl = URL.createObjectURL(blob);

        dispatch({
          type: DOWNLOAD_INVOICE_SUCCESS,
          payload: {
            fileUrl,
            blob,
            fileName: "Invoice_Report.pdf", 
          },
        });
      } catch (error) {
        dispatch({ type: DOWNLOAD_INVOICE_FAIL, payload: error });
      }
    };

export const downloadCSVFile =
  (file_name, response_data, reportType = "g") =>
    async (dispatch) => {
      try {
        dispatch({ type: DOWNLOAD_CSV_REQUEST });

        const config = {
          headers: {
            "Content-type": "application/json",
          },
          responseType: "blob",
        };

        const { data } = await axios.post(
          `${LOCAL_URL}/download_ticket_report_csv?report_type=${reportType}`,
          response_data,
          config
        );

        const blob = new Blob([data], {
          type: "text/csv",
        });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        if (file_name) {
          link.download = `${file_name}_report.csv`;
        } else {
          link.download = "Report.csv";
        }
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        dispatch({ type: DOWNLOAD_CSV_SUCCESS, payload: data });
      } catch (error) {
        dispatch({ type: DOWNLOAD_CSV_FAIL, payload: error });
      }
    };

export const createCustomerLogin =
  (customer_login_data) => async (dispatch) => {
    try {
      dispatch({ type: CREATE_CUSTOMER_LOGIN_REQUEST });
      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.post(
        `${LOCAL_URL}/cust/create_customer_login`,
        customer_login_data,
        config
      );

      dispatch({ type: CREATE_CUSTOMER_LOGIN_SUCCESS, payload: data });
    } catch (error) {
      dispatch({
        type: CREATE_CUSTOMER_LOGIN_FAIL,
        payload: error.response.data,
      });
    }
  };

export const getCustomerlogins = (search_value) => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_CUSTOMERS_LOGINS_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const url = search_value
      ? `${LOCAL_URL}/cust/get_all_customer_logins/${search_value}`
      : `${LOCAL_URL}/cust/get_all_customer_logins`;

    const { data } = await axios.get(url, config);

    dispatch({ type: GET_ALL_CUSTOMERS_LOGINS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_CUSTOMERS_LOGINS_FAIL, payload: error });
  }
};

export const updateCustomerLogins =
  (cust_login_id, updated_data) => async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_CUSTOMER_LOGINS_REQUEST,
      });

      const token = JSON.parse(localStorage.getItem("userInfo"));

      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };

      const { data } = await axios.put(
        `${LOCAL_URL}/cust/change_customer_logins_status/${cust_login_id}`,
        updated_data,
        config
      );

      dispatch({
        type: UPDATE_CUSTOMER_LOGINS_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: UPDATE_CUSTOMER_LOGINS_FAIL,
        palyload: error.response.data,
      });
    }
  };

export const getParentCustomers = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ALL_PARENT_CUSTOMERS_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.get(
      `${LOCAL_URL}/get_all_parent_customers`,
      config
    );

    dispatch({ type: GET_ALL_PARENT_CUSTOMERS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_PARENT_CUSTOMERS_FAIL, payload: error });
  }
};

export const removeCustomerLogo = (customerId) => async (dispatch) => {
  try {
    dispatch({ type: REMOVE_CUSTOMER_LOGO_REQUEST });

    const token = JSON.parse(localStorage.getItem("userInfo"));

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };

    const { data } = await axios.put(
      `${LOCAL_URL}/remove_customer_logo/${customerId}`,
      {},
      config
    );

    dispatch({ type: REMOVE_CUSTOMER_LOGO_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: REMOVE_CUSTOMER_LOGO_FAIL, payload: error });
  }
};
